const dialog = document.getElementById('omt-search-dialog');
const input = document.getElementById('omt-search-input');
const results = document.getElementById('omt-search-results');

if (dialog && input && results) {
  document.addEventListener('omt:search:open', () => {
    dialog.showModal();
    input.focus();
  });

  dialog.querySelector('[data-omt-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  results.addEventListener('click', (event) => {
    const suggestion = event.target.closest('[data-omt-suggested-term]');
    if (!suggestion) return;
    input.value = suggestion.textContent.trim();
    input.dispatchEvent(new Event('input'));
  });

  const runSearch = window.OMT.debounce(async (term) => {
    if (!term) return;
    const doc = await window.OMT.fetchSection(`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8`, 'predictive-search');
    const fresh = doc.getElementById('omt-search-results');
    if (fresh) results.innerHTML = fresh.innerHTML;
  }, 250);

  input.addEventListener('input', () => runSearch(input.value.trim()));
}
